export const BACKGROUND_COLOR = 'background-color';
export const FOREGROUND_COLOR = 'foreground-color';
export const TEXT_BUTTON_TEXT_COLOR = 'text-button-text-color';
export const TEXT_BUTTON_TEXT_HIGHLIGHT = 'text-button-text-highlight';
